module.exports = __webpack_public_path__ + "img/74.9.TU.86e0c1c8.png";